

export default {
    namespaced:true,
    state:{
        url:'https://madameclarissebackend.herokuapp.com',
        usuario:null,
        token:null
    },
    mutations:{
        setUsuario(state, payload){
            state.usuario = payload;
        },
        setToken(state, payload){
            state.token = payload;
        }
    },
    actions:{
       async login({commit, state}, payload){

            const res = await fetch(state.url+"/api/auth/login",{
                method:'POST',
                mode:'cors',
                headers:{
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    nombreUsuarioOrEmail:payload.nombreUsuarioOrEmail,
                    password:payload.password
                })
            });

            const datos = await res.json();

            if(res.status == 404){
                alert(datos.mensaje)
            }
            if(res.status == 201){
                commit("setToken", `${datos.tipoToken} ${datos.tokenAcceso}`);
                localStorage.setItem('token', `${datos.tipoToken} ${datos.tokenAcceso}`);
            }
        },
        leerToken({commit}){
           if(localStorage.getItem('token')){
               commit("setToken", localStorage.getItem('token'));
           }
        },
        cerrarSesion({commit}){
           localStorage.removeItem('token');
           commit('setToken', null);
        }
    },
    getters:{}
}